import { render, staticRenderFns } from "./product-editor.vue?vue&type=template&id=740a38ac&"
import script from "./product-editor.vue?vue&type=script&lang=js&"
export * from "./product-editor.vue?vue&type=script&lang=js&"
import style0 from "./product-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740a38ac')) {
      api.createRecord('740a38ac', component.options)
    } else {
      api.reload('740a38ac', component.options)
    }
    module.hot.accept("./product-editor.vue?vue&type=template&id=740a38ac&", function () {
      api.rerender('740a38ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-editor.vue"
export default component.exports